export default [{
  path: '/guest_car',
  name: 'guest_car',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/visitor/guestCar/index')
}]
